module.exports = __webpack_public_path__ + "static/media/erro-desbloqueio.eff2669a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/erro-desbloqueio.svg
// module id = 195
// module chunks = 0